import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { CheckIcon } from "@heroicons/react/24/outline";

const StepperComponent = () => {
  const [params, _setParams] = useSearchParams();
  const page_step = params.get("page_step");

  const [steps, setSteps] = useState([
    { id: "general_details", name: "General Details", status: "upcoming" },
    { id: "add_coupon", name: "Add Coupons", status: "upcoming" },
    { id: "membership_cms", name: "Setup CMS & Preview", status: "upcoming" },
  ]);

  useEffect(() => {
    const currentStepIndex = steps.findIndex((step) => step.id === page_step);
    const updatedSteps = steps.map((step, index) => {
      if (index < currentStepIndex) {
        return { ...step, status: "complete" };
      } else if (index === currentStepIndex) {
        return { ...step, status: "current" };
      } else {
        return { ...step, status: "upcoming" };
      }
    });
    setSteps(updatedSteps);
  }, [page_step]);

  return (
    <nav aria-label="Progress" className="py-3">
      <ol role="list" className="space-y-1 md:flex md:space-x-1 md:space-y-0">
        {steps.map((step) => (
          <li key={step.name} className="md:flex-1">
            {step.status === "complete" ? (
              <div className="group flex flex-col border-l-4 border-[#4D9FFF] py-2 pl-4 md:border-l-0 md:border-t-2 md:pb-0 md:pl-0 md:pt-2">
                <div className="flex items-center gap-2">
                  <a href="#" className="relative flex h-5 w-5 items-center justify-center rounded-full bg-[#4D9FFF]">
                    <CheckIcon aria-hidden="true" className="h-4 w-4 text-white" />
                  </a>
                  <span className="text-sm font-medium text-[#4F566B]">{step.name}</span>
                </div>
              </div>
            ) : step.status === "current" ? (
              <div
                aria-current="step"
                className="flex flex-col border-l-4 border-[#C1C9D2] py-2 pl-4 md:border-l-0 md:border-t-2 md:pb-0 md:pl-0 md:pt-2"
              >
                <div className="flex items-center gap-2">
                  <a
                    href="#"
                    aria-current="step"
                    className="relative flex h-5 w-5 items-center justify-center rounded-full border-2 border-[#4D9FFF] bg-white"
                  >
                    <span aria-hidden="true" className="h-2.5 w-2.5 rounded-full bg-[#4D9FFF]" />
                  </a>
                  <span className="text-sm font-medium text-[#4F566B]">{step.name}</span>
                </div>
              </div>
            ) : (
              <div className="group flex flex-col border-l-4 border-[#C1C9D2] py-2 pl-4  md:border-l-0 md:border-t-2 md:pb-0 md:pl-0 md:pt-2">
                <div className="flex items-center gap-2">
                  <a
                    href="#"
                    className="group relative flex h-5 w-5 items-center justify-center rounded-full border-2 border-gray-300 bg-white hover:border-gray-400"
                  >
                    <span
                      aria-hidden="true"
                      className="h-2.5 w-2.5 rounded-full bg-transparent group-hover:bg-gray-300"
                    />
                  </a>
                  <span className="text-sm font-medium text-[#4F566B]">{step.name}</span>
                </div>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default StepperComponent;
